(function(document) {
    
    var selectors = {
        pageContainer: '.page-container',
        siteHeader: '.site-header',
        blogDescription: '.blog-description',
      };
    
      let pageContainer = document.querySelector(selectors.pageContainer);
      let siteHeader = document.querySelector(selectors.siteHeader);
      let blogDescription = document.querySelector(selectors.blogDescription);
  
      let offsetMore = 40
      let blogDescriptionHeight = 0

      addEventListener("load", (event) => {
        if (blogDescription) {
          blogDescriptionHeight = blogDescription.offsetHeight
        }
        if (window.innerWidth > 1024) {
          offsetMore = 30
        }

        let marginTopContainer = blogDescriptionHeight + offsetMore

        pageContainer.style.marginTop = marginTopContainer + "px";
      })

})(document);
  